import { TOOLTIP } from '../../../../constants/tooltips'
import { AquiferEditFormInterface } from './aquifer-test-details-edit'
import { preventChangeOnScroll } from '../../../services/form-utils'
import { FormField, FormFieldRow, Heading, TextInput } from '@msaf/core-react'

export default function AquiferTestResultsEditForm({
  fields,
  isLoading,
  setValue,
  validationErrors,
}: AquiferEditFormInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Test results
      </Heading>
      <FormFieldRow>
        <FormField
          toolTipMessage={TOOLTIP.transmissivity}
          isSkeleton={isLoading}
          label='Transmissivity (m2/d)'
          htmlFor='transmissivity'
          validationMessages={validationErrors?.transmissivity}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id='transmissivity'
            value={`${fields.transmissivity ?? ''}`}
            setValue={(value) => setValue('transmissivity', value)}
            isInvalid={!!validationErrors?.transmissivity}
          />
        </FormField>

        <FormField
          isSkeleton={isLoading}
          label='Overlying aquifer - transmissivity (m2/d)'
          htmlFor='transmissivityOverlyingLayer'
          validationMessages={validationErrors?.transmissivityOverlyingLayer}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id='transmissivityOverlyingLayer'
            value={`${fields.transmissivityOverlyingLayer ?? ''}`}
            setValue={(value) => setValue('transmissivityOverlyingLayer', value)}
            isInvalid={!!validationErrors?.transmissivityOverlyingLayer}
          />
        </FormField>
      </FormFieldRow>
      <FormFieldRow>
        <FormField
          isSkeleton={isLoading}
          label='Storativity'
          htmlFor='storativity'
          validationMessages={validationErrors?.storativity}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id='storativity'
            value={`${fields.storativity ?? ''}`}
            setValue={(value) => setValue('storativity', value)}
            isInvalid={!!validationErrors?.storativity}
          />
        </FormField>

        <FormField
          isSkeleton={isLoading}
          label='Overlying aquifer - storativity'
          htmlFor='storativityOverlyingLayer'
          validationMessages={validationErrors?.storativityOverlyingLayer}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id='storativityOverlyingLayer'
            value={`${fields.storativityOverlyingLayer ?? ''}`}
            setValue={(value) => setValue('storativityOverlyingLayer', value)}
            isInvalid={!!validationErrors?.storativityOverlyingLayer}
          />
        </FormField>
      </FormFieldRow>

      <FormField
        toolTipMessage={TOOLTIP.aquiferTestDrawdown}
        isSkeleton={isLoading}
        label='Drawdown'
        htmlFor='drawdown'
        validationMessages={validationErrors?.drawdown}
      >
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='drawdown'
          value={`${fields.drawdown ?? ''}`}
          setValue={(value) => setValue('drawdown', value)}
          isInvalid={!!validationErrors?.drawdown}
        />
      </FormField>

      <FormField toolTipMessage={TOOLTIP.leakage} isSkeleton={isLoading} label='Leakage (m)' htmlFor='leakage'>
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='leakage'
          value={`${fields.leakage ?? ''}`}
          setValue={(value) => setValue('leakage', value)}
        />
      </FormField>

      <FormField isSkeleton={isLoading} label='K’/B’' htmlFor='kB' validationMessages={validationErrors?.kB}>
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='kB'
          value={`${fields.kB ?? ''}`}
          setValue={(value) => setValue('kB', value)}
          isInvalid={!!validationErrors?.kB}
        />
      </FormField>

      <FormField
        isSkeleton={isLoading}
        label='Assumed aquifer thickness (m)'
        htmlFor='assumedAquiferThickness'
        validationMessages={validationErrors?.assumedAquiferThickness}
      >
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='assumedAquiferThickness'
          value={`${fields.assumedAquiferThickness ?? ''}`}
          setValue={(value) => setValue('assumedAquiferThickness', value)}
          isInvalid={!!validationErrors?.assumedAquiferThickness}
        />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.conductivity}
        isSkeleton={isLoading}
        label='Hydraulic conductivity (m/d)'
        htmlFor='conductivity'
        validationMessages={validationErrors?.conductivity}
      >
        <TextInput
          isSkeleton={isLoading}
          type='number'
          onWheel={preventChangeOnScroll}
          id='conductivity'
          value={`${fields.conductivity ?? ''}`}
          setValue={(value) => setValue('conductivity', value)}
          isInvalid={!!validationErrors?.conductivity}
        />
      </FormField>
    </>
  )
}
